import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegionRoutingModule } from './region.routing';
import { RegionListComponent } from './list/region-list.component';
import { RegionSaveComponent } from './save/region-save.component';
import { RegionViewComponent } from './view/region-view.component';
import { RegionComponent } from './region.component';
import { TitlebarModule } from 'src/app/shared/titlebar/titlebar.module';
import { HeaderModule } from 'src/app/shared/header/header.module';
import { LoaderModule } from 'src/app/shared/loader/loader.module';
import { SnackbarModule } from 'src/app/shared/snackbar/snackbar.module';
import { SectionBarModule } from 'src/app/shared/sectionbar/sectionbar.module';
import { GridEmptyModule } from 'src/app/shared/gridempty/gridempty.module';
import { MatButtonModule, MatInputModule, MatTableModule, MatSlideToggleModule } from '@angular/material';
import { FabButtonGroupModule } from 'src/app/shared/fabbuttongroup/fabbuttongroup.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegionOficinaListComponent } from './listRegionOficina/region-oficina-list.component';

@NgModule({
  imports: [
    CommonModule,
    RegionRoutingModule,
    MatTableModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    FabButtonGroupModule,
    SectionBarModule,
    GridEmptyModule,
    TitlebarModule,
    HeaderModule,
    LoaderModule,
    SnackbarModule,
    MatSlideToggleModule
  ],
  declarations: [
    RegionListComponent,
    RegionSaveComponent,
    RegionViewComponent,
    RegionComponent,
    RegionOficinaListComponent,
  ]
})
export class RegionModule { }
